import React, {FunctionComponent, useCallback, useEffect, useMemo, useRef} from 'react'
import {useNavigation, useRootDispatch, useRootSelector} from '../../../../utils/hooks'
import {refsActions} from '../../../../redux/pages/settings/refs'
import refStyles from '../RefPage/RefPage.module.sass'
import styles from '../RefPage/RefPage.module.sass'
import {Table} from '../../../data-components/Table/Table/Table'
import {Column} from '../../../data-components/Table/Column'
import {Department} from '../../../../responses/departments'
import {Checkbox} from '../../../controls/Checkbox/Checkbox'
import {Lens} from 'monocle-ts'
import {RefIntersection, RefKey} from '../../../../responses/refs/refs'
import Field from '../../../controls/Field/Field'
import SearchIcon from 'files/search.svg'
import InfiniteScroll from '../../../etc/scroll/InfiniteScroll'

import Tabs from '../../../navigation/Tabs/Tabs'
import {useRouteMatch} from 'react-router'
import {ROUTES} from '../../../../http/routes'
import {NavLink} from 'react-router-dom'
import {urlWithParams} from '../../../../http/utils'

//const RefPage = lazy(() => import('../RefPage/RefPage'))
//const UsersPage = lazy(() => import('../UsersPage/UsersPage'))

const active = Lens.fromProp<Department>()('active')
const statistics_active = Lens.fromProp<Department>()('statistics_active')
const key: RefKey = 'department'

const DepartmentsPage: FunctionComponent = () => {
    const dispatch = useRootDispatch()
    const data = useRootSelector(state => state.pages.settings.refs.data[key] ?? [])
    const search = useRootSelector(state => state.pages.settings.refs.search[key] ?? '')

    const setSearch = useCallback((search: string) => {
        dispatch(refsActions.request.init({key, search, category: null}))
    }, [dispatch])

    useEffect(() => {
        setSearch(search)
    }, [setSearch, search])

    const listRef = useRef(null)
    useNavigation(listRef)

    const tabs = [{  // eslint-disable-line
        key: 'user',
        category: 'users',
        name: 'Сотрудники'
    }, {
        key: 'direction',
        category: 'users',
        name: 'Направления'
    }, {
        key: 'department',
        category: 'users',
        name: 'Отделы'
    }]
    const match = useRouteMatch<{ key: RefKey }>(ROUTES.SETTINGS_REF)
    const selected = useMemo(() => tabs.find(tab => tab.key === match?.params.key), [match?.params?.key, tabs])

    return <div className={refStyles.refPage}>
        <div className={styles.headerMenu}>
            <Tabs
                items={tabs}
                itemToKey={tab => tab.key}
                selected={selected}
                renderer={tab => <NavLink
                    key={tab.key}
                    to={urlWithParams({key: tab.key})(ROUTES.SETTINGS_REF)}
                >
                    {tab.name}
                </NavLink>}
            />

        </div>
        <div className={refStyles.header}>
            <Field placeholder={'Поиск'} value={search} onChange={setSearch} rightItem={<SearchIcon/>}/>
        </div>
        <InfiniteScroll
            ref={listRef}
            className={styles.body}
            onReach={() => dispatch(refsActions.request.more(key))}
        >
            <Table className={refStyles.table} data={data}>
                <Column<Department> headerRenderer={'Название'} cellRenderer={department => department.title}/>
                <Column<Department>
                    headerRenderer={'Активность'}
                    cellRenderer={department => <Checkbox
                        value={department.active}
                        onChange={value => dispatch(refsActions.update.request({
                            key,
                            old: department as RefIntersection,
                            changes: active.set(value)(department) as RefIntersection
                        }))}
                    />}
                />
                <Column<Department>
                    headerRenderer={'Статистика'}
                    cellRenderer={department => <Checkbox
                        value={department.statistics_active}
                        onChange={value => dispatch(refsActions.update.request({
                            key,
                            old: department as RefIntersection,
                            changes: statistics_active.set(value)(department) as RefIntersection
                        }))}
                    />}
                />
            </Table>
        </InfiniteScroll>
    </div>
}

export default DepartmentsPage